import { cn } from '@/lib/utils';

interface ImageIndicatorProps {
  total: number;
  current: number;
  onSelect?: (index: number) => void;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
}

export function ImageIndicator({
  total,
  current,
  onSelect,
  className,
  activeClassName = "bg-pastel-purple w-2 h-2 rounded-full hover:bg-pastel-purple/80 hover:scale-110 transition-all duration-300",
  inactiveClassName = "bg-white/50 hover:bg-white/70 w-2 h-2 hover:scale-110 transition-all duration-300 rounded-full"
}: ImageIndicatorProps) {
  return (
    <div className={cn("flex gap-2", className)}>
      {Array.from({ length: total }).map((_, index) => (
        <button
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            onSelect?.(index);
          }}
          className={cn(
            "rounded-full transition-all",
            index === current
              ? activeClassName
              : inactiveClassName
          )}
          aria-label={`画像 ${index + 1}`}
        />
      ))}
    </div>
  );
}
